import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

const DownloadButton = ({ exportCSV, exportExcel, exportPdf }) => {
  const [visible, setVisible] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState(null);

  const formats = [
    { label: ".CSV", action: exportCSV },
    { label: ".Excel", action: exportExcel },
    { label: ".PDF", action: exportPdf },
  ];

  const handleExport = () => {
    if (selectedFormat) {
      selectedFormat.action();
      setVisible(false);
      setSelectedFormat(null);
    }
  };

  const toggleFormat = (format) => {
    if (selectedFormat && selectedFormat.label === format.label) {
      setSelectedFormat(null); // Unselect if the same format is clicked
    } else {
      setSelectedFormat(format); // Select the clicked format
    }
  };

  return (
    <div className="report-buttons-datagrid">
      <button className="btn btn-primary" onClick={() => setVisible(true)}>
        <i className="pi pi-download"></i> Download
      </button>

      <i
        className="pi pi-download download-i hide"
        onClick={() => setVisible(true)}
      ></i>

      <Dialog
        header={<span style={{ fontWeight: 400 }}>Download as</span>}
        visible={visible}
        style={{ width: "400px" }}
        onHide={() => {
          setVisible(false);
          setSelectedFormat(null);
        }}
      >
        <div className="w-full">
          <div>
            {formats.map((format) => (
              <div key={format.label} className="flex items-center gap-2 pb-3">
                <Checkbox
                  inputId={format.label}
                  onChange={() => toggleFormat(format)}
                  checked={selectedFormat?.label === format.label}
                />
                <label htmlFor={format.label} className="">
                  {format.label}
                </label>
              </div>
            ))}
          </div>

          {/* Button Container */}
          <div className="flex gap-3 justify-content-end mt-4">
            <Button
              label="Close"
              className="button-down-close"
              onClick={() => {
                setVisible(false);
                setSelectedFormat(null);  
              }}
            />
            <Button
              label="Submit"
              className={`button-down-submit ${!selectedFormat ? "button-down-disabled" : ""
                }`}
              onClick={handleExport}
              disabled={!selectedFormat}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DownloadButton;
